"use strict";

const debounce = require("./debounce");
const grade = window.grade;
let $postContainer = null;
let $form = null;
let $previous_form_request = [];
const MAX_SEARCH_ITERATIONS = 6;
let shouldUpdateUrlParams = true;

module.exports = function($) {
  return {
    init: init,
  };

  function init() {
    $postContainer = $(".ajax-map-result-container");
    $form = $("[data-filter-search-map]");

    if ($form) {
      filterLocationResults();
      outputRangeValue();
      addEventListener('popstate', () => {
        popStateHandler();
      })
    }
  }

  function outputRangeValue(value = null) {
    var $range = $('.range-input input[type="range"');
    var $displayElement = $range
      .parents(".range-input")
      .find(".range-input__counter span");

    if (value) {
      $displayElement.html(value);
    }

    $range.on("input", function (event) {
      $displayElement.html(event.target.value);
    });
  }

  function updateUrlParams(formData = [], attemptCount = 0) {
    // only push state on first data lookup
    // in order to retain back button functionality
    if (attemptCount < 1) {
      // update URL Parameters
      const location_address = formData['location_address'] ?? formData['location_address'];
      const gmst_acf_city_lat = formData['gmst_acf_city_lat'] ?? formData['gmst_acf_city_lat'];
      const gmst_acf_city_lng = formData['gmst_acf_city_lng'] ?? formData['gmst_acf_city_lng'];
      const service_filter_terms = formData['service_filter_terms'] ?? formData['service_filter_terms'];
      const gmst_acf_field_range = formData['gmst_acf_field_range'] ?? formData['gmst_acf_field_range'];

      let state = {
        location_address,
        gmst_acf_field_range,
        gmst_acf_city_lat,
        gmst_acf_city_lng,
        service_filter_terms,
      };
      // remove empty/null values from state
      state = Object.keys(state)
        .filter((key) => state[key] != null)
        .reduce((a, key) => ({ ...a, [key]: state[key] }), {});
      // build params
      var params = new URLSearchParams(state);
      const urlWithParams = '?' + params;
      history.pushState(state, '', urlWithParams);

      // Update Language Switcher links
      // forces update of the URLs in lang switcher to include new params,
      // otherwise they are outdated
      const links = $('a.wpml-ls-link');
      links.each(function () {
        const href = $(this).attr('href');
        const url = href.split('?')[0] + urlWithParams;
        $(this).attr('href', url.toString());
      })

    }
  }

  function popStateHandler() {
    onpopstate = (event) => {
      const formState = event.state;
      if (formState) {
        shouldUpdateUrlParams = false;
        // set form values from state, only when they exist
        $form
          .find("[name='location_address']")
          .val(formState['location_address'] ?? formState['location_address']);
        $form
          .find("[name='gmst_acf_field_range']")
          .val(formState['gmst_acf_field_range'] ?? formState['gmst_acf_field_range']);
        $form
          .find("[name='gmst_acf_city_lat']")
          .val(formState['gmst_acf_city_lat'] ?? formState['gmst_acf_city_lat']);
        $form
          .find("[name='gmst_acf_city_lng']")
          .val(formState['gmst_acf_city_lng'] ?? formState['gmst_acf_city_lng']);

        // set terms checkboxes
        const $terms = $form.find("[name='service_filter_terms']")

        $terms.each(function () {
          const termValue = $(this).val();
          if (formState['service_filter_terms'] && formState['service_filter_terms'].includes(termValue)) {
            $(this).prop('checked', true);
          } else {
            $(this).prop('checked', false);
          }
        });

        // submit modified form data
        $form.submit();
      }
    }
  }

  function filterLocationResults() {
    const $noResultMessage = jQuery("[data-services-no-result]");
    var $errorMessage = jQuery('#gmst_search_error');

    debounceFilter();

    function enableForm() {
      $form
        .stop()
        .removeClass("is-submitting")
        .find("[data-search-button]")
        .removeAttr("disabled");

      $(".gmst_search_error").fadeOut();
      shouldUpdateUrlParams = true;

    }

    function debounceFilter() {
      const doFilter = debounce(submitForm, 600);

      $form.on("submit change", function (e) {
        e.preventDefault(); // Prevent the default form submission
        e.stopPropagation();
        doFilter();
      });
    }

    function submitForm(rangeOverrideCount = 0) {
      // Get form data
      $form.addClass("is-submitting");
      const formData = {};
      const formDataArray = $form.serializeArray();
      $errorMessage.stop().slideUp();

      formDataArray.map((field) => {
        // for duplicate keys, merge values
        const hasKey = field.name in formData;
        if (hasKey) {
          // cheat to get around wp string
          formData[field.name] = formData[field.name] + "," + field.value;
        } else {
          if (field.value) {
            formData[field.name] = field.value;
          }
        }
      });

      // manually increase range when no results
      if (rangeOverrideCount > 0) {
        const currentRange = Math.floor(formData["gmst_acf_field_range"]);
        const multiplier = currentRange * (rangeOverrideCount * 2.5);
        formData["gmst_acf_field_range"] = Math.floor(
          (currentRange + multiplier) * rangeOverrideCount
        );
      }

      if (rangeOverrideCount >= MAX_SEARCH_ITERATIONS) {
        // go big
        formData["gmst_acf_field_range"] = 2000;
      }

      // console.log(
      //   `#${rangeOverrideCount} attempt:`,
      //   formData
      // );

      const data = {
        action: "grade_ajax_filter_map_results",
        nonce: grade.ajax_post_nonce,
        ...formData,
      };

      // if not same data, make request
      if ($previous_form_request !== formData) {
        if (shouldUpdateUrlParams) {
          updateUrlParams(formData, rangeOverrideCount);
        }

        jQuery.ajax({
          type: "POST",
          url: grade.ajax_url,
          data,
          success: function (res) {
            if (res.success) {
              // increase range if no data
              if (!res.data) {
                rangeOverrideCount++;
                // iterate limited number of times
                if (rangeOverrideCount <= MAX_SEARCH_ITERATIONS) {
                  debounce(submitForm(rangeOverrideCount), 2000);
                }
              } else {
                $postContainer.html(res.data);

                // animate in cards
                const $cards = $postContainer.find(".card");

                $cards.each(function (index) {
                  jQuery(this)
                    .fadeTo(0, 0)
                    .delay(index * 100)
                    .fadeTo(400, 1);
                });

                window.initServicesMap();

                if (rangeOverrideCount <= MAX_SEARCH_ITERATIONS) {
                  outputRangeValue(formData["gmst_acf_field_range"]);
                }

                // show "no result in range" message
                if (rangeOverrideCount > 0) {
                  $noResultMessage.stop().fadeIn(500);
                } else {
                  $noResultMessage.stop().fadeOut(300);
                }
              }

              enableForm();
              $previous_form_request = formData;
            }
          },
          error: function (xhr) {
            //
            enableForm();
          },
        });
      }
    }
  }
};
